import { render, staticRenderFns } from "./updateServiceName.vue?vue&type=template&id=8a16a3c6&scoped=true&"
import script from "./updateServiceName.vue?vue&type=script&lang=js&"
export * from "./updateServiceName.vue?vue&type=script&lang=js&"
import style0 from "./updateServiceName.vue?vue&type=style&index=0&id=8a16a3c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a16a3c6",
  null
  
)

export default component.exports